import Layout from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { Building2 } from "lucide-react";

export default function PmoShell({ title, subtitle, testid, actions, children, supervisorOnly = false }) {
  const { user } = useAuth();
  const allowed = !supervisorOnly || ["supervisor", "admin"].includes(user?.role);
  if (!allowed) return (
    <Layout>
      <div className="max-w-lg mx-auto text-center py-24" data-testid="pmo-restricted">
        <Building2 className="h-10 w-10 text-emerald-600 mx-auto mb-4" />
        <h1 className="font-display text-2xl font-extrabold tracking-tight">PMO layer</h1>
        <p className="text-muted-foreground mt-2">This PMO tool is available to supervisors and admins. Ask your workspace admin for access.</p>
      </div>
    </Layout>
  );
  return (
    <Layout>
      <div className="space-y-8" data-testid={testid}>
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-3 py-1">
              <Building2 className="h-3.5 w-3.5" /> PMO layer
            </span>
            <h1 className="font-display text-4xl font-extrabold tracking-tight mt-3">{title}</h1>
            {subtitle && <p className="text-muted-foreground mt-2 max-w-2xl">{subtitle}</p>}
          </div>
          {actions}
        </div>
        {children}
      </div>
    </Layout>
  );
}
